import { FC, useEffect, useState } from "react";
import styles from './index.module.less';
import Title from '../../common/title';
import FileItem from './FileItem';
import { getFileList } from '../../api/index';

const Index: FC = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getList = async () => {
        const res = await getFileList(1, 7);
        if (res.list) {
            setData(res.list);
            setLoading(false);
        }
    }

    useEffect(() => {
        getList();
    }, []);
    return (
        <div style={{height: props.height, width: props.width}} className={styles.body}>
            <Title hasMore={true} path='/download' title={'文件下载'}></Title>
            <div className={styles.content}>
                {
                    loading ?
                    <div className={styles.loading}>加载中...</div>
                    :
                    data.map((item) => {
                        return (<FileItem {...item} />);
                    })
                }
            </div>
        </div>
    );
}

export default Index;